import store from '../store';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { getFirstAllowedRouteName } from '@/permissions';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    },
    {
        path: '/lost-password',
        name: 'lostPassword',
        component: () => import(/* webpackChunkName: "lostPassword" */ '../views/LostPassword.vue'),
    },
    {
        path: '/lost-login',
        name: 'lostLogin',
        component: () => import(/* webpackChunkName: "lostLogin" */ '../views/LostLogin.vue'),
    },
    {
        path: '/initpassword/:token',
        name: 'initPassword',
        component: () => import(/* webpackChunkName: "initPassword" */ '../views/InitPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/contracts',
        name: 'contracts',
        component: () => import(/* webpackChunkName: "contracts" */ '../views/Contracts.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/users',
        name: 'users',
        component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/clusters',
        name: 'clusters',
        component: () => import(/* webpackChunkName: "clusters" */ '../views/Clusters.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/application-types',
        name: 'applicationTypes',
        component: () => import(/* webpackChunkName: "applicationTypes" */ '../views/ApplicationTypes.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/devices',
        name: 'devices',
        component: () => import(/* webpackChunkName: "devices" */ '../views/Devices.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/sessions',
        name: 'sessions',
        component: () => import(/* webpackChunkName: "sessions" */ '../views/Sessions.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/mosaics',
        name: 'mosaics',
        component: () => import(/* webpackChunkName: "mosaics" */ '../views/Mosaics.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    },
    {
        path: '/hls',
        name: 'hls',
        component: () => import(/* webpackChunkName: "hls" */ '../views/HLS.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/vod',
        name: 'vod',
        component: () => import(/* webpackChunkName: "vod" */ '../views/VOD.vue'),
        meta: {
            requiresAuth: true,
        },
    },
];

const router = new VueRouter({
    mode: 'hash',
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.name == 'login' && store.getters.user) {
        next({ name: getLandingPage() });
    } else if (to.matched.some((record) => record.meta.requiresAuth) && !store.getters.user) {
        next({ name: 'login' });
    } else {
        next();
    }
});

export function getLandingPage() {
    return getFirstAllowedRouteName();
}

export default router;
